import { cloneDeep } from "lodash";
import store from "@/vuex/store";
import { ACTION_NAME } from "@/constants/dynamicSchedulingConstants";

export default class WebSocketService {
  socket = null;
  message = null;
  messageCount = 0;
  params = null;

  async establishWebSocketAndListeners(params) {
    await this.createSocket(params);
    this.openSocket();
    this.listenMessageSocket();
    this.isSocketClosed();
  }

  createSocket(params) {
    try {
      this.params = params;
      const socketUrl = `${process.env.VUE_APP_WEB_SOCKET_BASE_URL}/websocket?id=${params.id}&clientId=${params.clientId}&participantId=${params.participantId}&studyId=${params.studyId}&languageId=${params.languageId}&studyVerId=${params.studyVerId}`;
      this.socket = new WebSocket(socketUrl);
      return this.socket;
    } catch (e) {}
  }

  openSocket() {
    try {
      this.socket.addEventListener("open", () => {
        this.socket.send("Hello Server!");
      });
    } catch (e) {}
  }

  listenMessageSocket() {
    try {
      this.socket.addEventListener("message", event => {
        switch (cloneDeep(JSON.parse(event.data)).actionType) {
          case ACTION_NAME.ADD_AN_ACTIVITY:
            break;
          case ACTION_NAME.REMOVE_AN_ACTIVITY:
            break;
          default:
            break;
        }

        this.message = cloneDeep(JSON.parse(event.data));
        this.messageCount++;
      });
    } catch (e) {}
  }

  isSocketClosed() {
    try {
      this.socket.addEventListener("close", event => {
        const wss = store.getters.getWebSocketServiceData;
        if ((event && event.target && event.target.readyState === 3) || (event.currentTarget && event.currentTarget.readyState === 3) || (event.srcElement && event.srcElement.readyState === 3)) {
          wss.establishWebSocketAndListeners(wss.params);
        }
      });
    } catch (e) {}
  }
}

export function setSocketConnection(params) {
  const wss = new WebSocketService();
  wss.establishWebSocketAndListeners(params);
  store.dispatch("setWebSocketServiceData", wss);
}

// commenting following bit of code out, as we may need this POC in future.
/* export function sendPushNotification( data ) {
    if ("Notification" in window && Notification.permission === "granted") {
        // Check if the browser supports notifications
        const notification = new Notification('THREAD',{ body: "New Activity Available" });
      }
} */
